import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';
import { Binder, UserBinder } from '@models/binder.model';
import { BinderService } from '@services/binder.service';
import { NotificationService } from '@services/notification.service';
import { Router } from '@services/route.service';
import { ScannerService } from '@services/scanner.service';

@Component({
  selector: 'lgb-litle-binder',
  imports: [
    CommonModule,
    UiModule
  ],
  templateUrl: './litle-binder.html',
  styleUrl: './litle-binder.css',
})
export class LitleBinder {
  readonly uBinder=input.required<UserBinder>();
  readonly binder=input.required<Binder>();
  readonly admin=input(true);
  readonly loading=output<boolean>({alias: 'isLoading'});
  readonly error=output<string>();

  readonly binderS=inject(BinderService);
  readonly scanService=inject(ScannerService);
  readonly router=inject(Router);
  readonly notify=inject(NotificationService);

  getImgBinder(){
    let img: string=null;
    if(this.binder())
      img=this.binder().img;
    return [this.binderS.getImg(img)];
  }

  setScan(){
    this.scanService.enable('binder', this.uBinder().ident);
  }

  rmBinder(){
    if(confirm('Voulez-vous supprimer ce binder ?')){
      this.loading.emit(true);
      this.binderS.rmUserBinder(this.uBinder().ident)
        .subscribe({
          next: () => {
            this.loading.emit(false);
            this.notify.notifySuccess(this.getMsgRm());
            this.router.navigate('collect-home');
          },
          error: e => {
            this.loading.emit(false);
            this.error.emit(e);
          }
        });
    }
  }

  getMsgRm(){
    let msg: string='Binder supprimé.';
    if(this.uBinder().binder)
      msg=`Binder #${this.uBinder().ident} supprimé`;
    return msg;
  }


  toggleFavoriteBinder(){
    this.binderS.toggleFavoriteBinder(this.uBinder().ident)
      .subscribe(uBinder => this.uBinder().isFavorite=uBinder.isFavorite);
  }
}
